import { render, staticRenderFns } from "./nlp.vue?vue&type=template&id=200f1ebc"
import script from "./nlp.vue?vue&type=script&lang=js"
export * from "./nlp.vue?vue&type=script&lang=js"
import style0 from "../assets/sass/commponents/nlp.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports